import React, { forwardRef, useEffect, useRef, useState } from 'react'
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, Input, InputLabel, List, ListItem, MenuItem, Select, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material'
import '../../../assets/ExtraStyle.css'
import { Cancel, CancelOutlined, Edit, Info } from '@mui/icons-material';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import QuestionList from '../QuestionLists/QuestionList.tsx';
import { AddBusinessQuestions, AddVenueQuestions, ApiaddvenuequestionsWithTemplateId, ApiCopyVenueCategoryQuestion, ApiCreateSampleAllocation, ApiDeleteCatgory, ApiDowloadQuestions, ApiGetQuestionUsage, ApiGetVenueList, ApiGetVenueQuestionExcel, ApiReportTempToken, ApiSampleReport, ApiUpdateQuestionOption, GetCategories, GetClientEntityQuestions, GetQuestionTemplate, GetTemplateQuestions, GetVenueQuestions, RemoveClientQuestions, RemoveTemplateQuestions, RemoveVenueQuestions, UpdateBusinessQuestions, UpdateVenueCategoryOrder, UpdateVenueQuestionOrder, UpdateVenueQuestions } from '../../../apiService/Core/Apicall.tsx';
import edit from '../../../assets/images/editIcon.png'
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { downloadQuestions, updatevenuequestionorder } from '../../../apiService/Core/ApiEndPoint.tsx';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from 'react-redux';
import { RootState } from '../../../global/config/store.ts';

interface DragItem {
    index: number;
}

const QuestionCard = forwardRef(({ clientData, question, index, moveQuestion, editId, setreload, questionGroup, questionLabel, setquestionGroup, setquestionLabel, maxScore, setmaxScore, colorHex, setcolorHex, removequestion, updatequestion, setEditId, setEditWeighted, editWeighted }: { clientData: any, question: any; editId: string | null; colorHex: string | number | undefined; questionGroup: string | undefined, questionLabel: string | undefined, index: number; moveQuestion: (from: number, to: number) => void; removequestion: (id: number) => void; updatequestion: (id: number) => void; setEditId: (id: string | null) => void; setEditWeighted: (weight: number | string) => void; setmaxScore: (score: number | string) => void; setcolorHex: (colorHex: number | string) => void; setquestionGroup: (questionGroup: string) => void; setquestionLabel: (questionLabel: string) => void; editWeighted: any; maxScore: any; setreload: (reload: boolean) => void; }, ref) => {
    const dragRef = useRef<any>(null);
    const dropRef = useRef<any>(null);
    const navigate = useNavigate()
    const DISABLE_DND = true;

    const [newOptionValue, setnewOptionValue] = useState<string>();
    const [editedOptiondata, setEditedOptiondata] = useState<any>()
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const [openQuestionUsage, setOpenQuestionUsage] = useState<boolean>(false)
    const [questionUsageList, setQuestionUsageList] = useState<any>([])




    const handleSaveNewOption = async () => {
        try {
            const isConfirm = window.confirm("This will update option text for all past, current and future reports. Do you want to proceed ?")
            if (isConfirm) {
                const data = {
                    optionId: editedOptiondata?.optionId,
                    questionId: question.questionId.questionId,
                    clientGroupName: selectedClientName?.clientGroupName,
                    newValue: newOptionValue,
                    oldValue: JSON.parse(question.questionId.qOptionJson)?.find((item: any) => item?.optionId == editedOptiondata?.optionId)?.value
                }
                const response = await ApiUpdateQuestionOption(data)
                if (response?.success) {
                    setEditedOptiondata({})
                    setreload(true)
                }

            }
            else {
                setEditedOptiondata({})
            }
        } catch (error: any) {
            toast.error(error?.message)
        }
    }

    const [, drag] = useDrag({
        type: 'QUESTION',
        item: { index },
    });

    const [, drop] = useDrop({
        accept: 'QUESTION',
        hover: (draggedItem: DragItem) => {
            if (draggedItem.index !== index) {
                moveQuestion(draggedItem.index, index);
                draggedItem.index = index;
            }
        },
    });

    if (!DISABLE_DND) {
        drag(dragRef);
        drop(dropRef);
    }
    function decodeHtml(html) {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }

    const getQuestionUsage = async (questionId: number | string) => {
        try {
            const data = `?questionId=${questionId}`
            const res = await ApiGetQuestionUsage(data)
            if (res?.status) {
                setQuestionUsageList(res?.data)
                setOpenQuestionUsage(true)
            }
        } catch (error: any) {
            toast.error(error?.messsage)
        }
    }

    return (
        <Box ref={(node) => {
            dragRef.current = node;
            dropRef.current = node;
        }} key={index} className='my-2' border='1px solid #E0E0E0' borderRadius='5px' padding='10px'>
            <Box className='w-100 d-flex justify-content-end'>
                <Typography variant='caption' className='text-end'>Index: {index}</Typography>
            </Box>
            <Box className='d-flex align-items-center justify-content-between my-3'>
                <Box className='d-flex align-items-center' gap={1}>
                    <Typography className='text-main fw-bold'>Question ID: #{question.questionId.questionId}</Typography>
                    <Typography className='text-main fw-bold'>|</Typography>
                    <Typography className='fw-bold'>Category: {question.questionId.categoryId?.categoryName}</Typography>
                    <Typography className='fw-bold'>|</Typography>
                    <Typography className='fw-bold'>Type: {question?.questionId.qType?.length > 0 ? question.questionId.qType === "R" ? "Radio" : question.questionId.qType === "r" ? 'Radio Rating' : question.questionId.qType === "C" ? 'CheckBox' : "Text" : 'notFound'}</Typography>
                </Box>
                <Box className='d-flex align-items-center' gap={1}>
                    {/* <IconButton className='px-4 py-1 transform text-light' onClick={() => {
                        navigate(`/admin/create-new-question`, {
                            state: { questionData: question.questionId, venueId: clientData?.venueId },
                        });
                    }}><img src={edit} height='25px'></img></IconButton> */}
                    <Link
                        to={`/admin/create-new-question/venue/${clientData?.venueId}/${question.questionId.questionId}`}
                        className='px-4 py-1 transform text-light'

                    ><img src={edit} height='25px'></img></Link>
                    <Button onClick={() => { getQuestionUsage(question.questionId.questionId) }} className="link-btn whitespace text-white" sx={{ textTransform: 'none' }}>
                        Usage
                    </Button>
                    <Button className='px-4 py-1 bg-danger transform text-light' onClick={() => { removequestion(question.clientEntityQuestionVenueId) }}>- Remove</Button>
                    {editId === question.questionId.questionId && <Button className='px-3 py-1 bg-grey transform text-light' onClick={() => { updatequestion(question.clientEntityQuestionVenueId) }}>Save</Button>}
                    {editedOptiondata?.optionId && <Button className='px-3 py-1 bg-grey transform text-light' onClick={() => { handleSaveNewOption() }}>Save Option</Button>}
                </Box>
            </Box>
            <Box>
                <Typography className='fw-bold my-1 d-flex'>Q:&nbsp;<span dangerouslySetInnerHTML={{ __html: question.questionId.questions }} /></Typography>
                <Box className='d-flex align-items-center' gap={3}>
                    <Box className='d-flex align-items-center'>
                        {/* <Box className='px-4 py-1 text-main' borderRight='1px solid #747247' bgcolor='#7472471A'>
                        <Typography>Ver {question.questionId.verNo}</Typography>
                    </Box> */}
                        <Typography className='px-4 my-2 py-1 text-main bg-light-primary'>{question.questionId.entityTypeId?.entityTypeName || 'undefined'}</Typography>
                    </Box>
                    {question.questionId.isPhotoRequire && (
                        <Box className=" bg-light-primary px-4 py-2" borderRadius='20px' width='fit-content'>
                            <Typography>Images - Min: {question.questionId.minPhoto}</Typography>
                        </Box>
                    )}
                </Box>
                {question.questionId.qOptionJson !== null && question.questionId.qOptionJson !== "" ? (
                    <List component='ol' className="question-options w-100 d-flex justify-content-between flex-wrap">
                        {(() => {
                            try {
                                const parsedOptions = JSON.parse(question.questionId.qOptionJson);
                                return parsedOptions.map((option, index) => (
                                    <ListItem key={index} className="col-6 option-text">
                                        <span>{index + 1}. &nbsp;</span>
                                        <span className='col'>
                                            <TextField multiline value={editedOptiondata?.optionId == option?.optionId ? newOptionValue ?? option.value : option?.value}
                                                variant={editedOptiondata?.optionId != option?.optionId ? "standard" : "outlined"}
                                                fullWidth
                                                onChange={(e) => { setnewOptionValue(e.target.value) }}
                                                InputProps={{
                                                    disableUnderline: true  // removes bottom border
                                                }}
                                                sx={{
                                                    m: 0,
                                                    p: 0,
                                                    outline: 'none',
                                                    backgroundColor: editedOptiondata?.optionId != option?.optionId ? "transparent" : "white",

                                                    "& .MuiInputBase-root": {
                                                        padding: 0,
                                                        backgroundColor: "transparent",
                                                        border: 'none',
                                                        outline: 'none'
                                                    },

                                                    "& textarea": {
                                                        padding: 0,
                                                        margin: 0,
                                                        backgroundColor: "transparent",
                                                        resize: "none",
                                                        border: 'none',
                                                    },
                                                }}

                                                name={index}
                                                disabled={editedOptiondata?.optionId != option?.optionId}
                                                className='option-text m-0 p-0 w-100' />
                                        </span>
                                        {/* <span dangerouslySetInnerHTML={{ __html: option.value }} /> &nbsp; */}
                                        <span>(<span dangerouslySetInnerHTML={{ __html: option.optionScore }} />)</span>
                                        {option.radioRatingComment && (
                                            <span className="ml-1">({option.radioRatingComment})</span>
                                        )}
                                        <Tooltip
                                            title={
                                                <Box>
                                                    <Typography variant='caption' display={'block'}><b>optionComment: </b> {option?.optionComment}</Typography>
                                                    <Typography variant='caption' display={'block'}><b>minChar: </b> {option?.minChar}</Typography>
                                                    <Typography variant='caption' display={'block'}><b>optionCommentType: </b> {option?.optionCommentType ?? "N/A"}</Typography>
                                                    {option?.optionImage && (<Typography variant='caption' display={'block'}><b>optionImage: </b> {option?.optionImage}</Typography>)}
                                                </Box>
                                            }
                                        >
                                            <Info sx={{ fontSize: '16px', marginLeft: "8px" }} />
                                        </Tooltip>
                                        {(editedOptiondata?.optionId && editedOptiondata?.optionId == option?.optionId) ?
                                            (
                                                <IconButton
                                                    onClick={() => {
                                                        setEditedOptiondata({});
                                                    }}>
                                                    {/* <Tooltip title='Edit Option' style={{ cursor: 'pointer' }}> */}
                                                    <Cancel sx={{ fontSize: '16px', fill: 'red' }} />
                                                    {/* </Tooltip> */}
                                                </IconButton>)
                                            : (
                                                <IconButton
                                                    onClick={() => {
                                                        // setisEditOption(true);
                                                        setEditedOptiondata((prev: any) => ({
                                                            ...prev,
                                                            optionId: option?.optionId,
                                                        }));
                                                        setnewOptionValue(option?.value)
                                                    }}>
                                                    <Tooltip title='Edit Option' style={{ cursor: 'pointer' }}>
                                                        <Edit sx={{ fontSize: '16px', }} />
                                                    </Tooltip>
                                                </IconButton>
                                            )

                                        }


                                    </ListItem>
                                ));
                            } catch (error) {
                                console.error("Invalid JSON in qOptionJson:", error);
                                return (
                                    <Typography className="option-text text-danger">
                                        Error: Invalid JSON format
                                    </Typography>
                                );
                            }
                        })()}
                    </List>
                ) : (
                    <Typography className="option-text">
                        Answer will be a manual Text Entry
                    </Typography>
                )}
                <Box className='d-flex mb-2 align-items-stretch flex-wrap'>
                    <Box className='px-4 py-1 text-main align-items-center d-flex' width='fit-content' borderRight='1px solid #747247' bgcolor='#7472471A'>
                        <Typography>Score : &nbsp;</Typography>
                        <FormControl>
                            <TextField
                                type='number'
                                onBlur={(e) => {
                                    const value = parseInt(e.target.value, 10);
                                    if (isNaN(value) || value < 0) {
                                        toast.error('Number Should be positive')
                                        setmaxScore(question.maxScore)
                                    }
                                }}
                                inputProps={{ min: 0 }}
                                disabled={editId !== question.questionId.questionId}
                                sx={{
                                    width: '50px',
                                    "& .MuiOutlinedInput-input": {
                                        color: "#747247",
                                        border: 'none !important',
                                        padding: '0px !important'
                                    },
                                    textAlign: 'center', border: 'none'
                                }}
                                onChange={(e) => { setmaxScore(e.target.value) }}
                                value={editId === question.questionId.questionId ? maxScore ? maxScore : question.maxScore ?? "" : question.maxScore ?? ""} />
                        </FormControl>
                        <Box component='img' onClick={() => setEditId(question.questionId.questionId)} src={edit} width='20px' height='20px'></Box>
                    </Box>
                    <Box className='px-4 d-flex align-items-center py-1 text-main' gap={2} width='fit-content' bgcolor='#7472471A' borderRight='1px solid #747247'>
                        <Typography width='fit-content' className='d-flex align-items-center'>Weightage : &nbsp;  </Typography>
                        <FormControl>
                            <TextField
                                type='number'
                                onBlur={(e) => {
                                    const value = parseInt(e.target.value, 10);
                                    if (isNaN(value) || value < 0) {
                                        toast.error('Number Should be positive')
                                        setEditWeighted(question.questionWeightage || Number(maxScore) === 0)
                                    }
                                }}
                                inputProps={{ min: 0 }}
                                disabled={editId !== question.questionId.questionId}
                                sx={{
                                    width: '50px',
                                    "& .MuiOutlinedInput-input": {
                                        color: "#747247",
                                        border: 'none !important',
                                        padding: '0px !important'
                                    },
                                    textAlign: 'center', border: 'none'
                                }}
                                onChange={(e) => { setEditWeighted(e.target.value) }}
                                value={editId === question.questionId.questionId ? editWeighted ? editWeighted : question.questionWeightage ?? "" : question.questionWeightage ?? ""} />
                        </FormControl>
                        <Box component='img' onClick={() => setEditId(question.questionId.questionId)} src={edit} width='20px' height='20px'></Box>
                    </Box>
                    <Box className='px-4 d-flex align-items-center py-1 text-main' gap={1} width='fit-content' bgcolor='#7472471A'>
                        <Typography width='fit-content' className='d-flex align-items-center'>colour : &nbsp;</Typography>
                        <FormControl>
                            <TextField
                                type='color'
                                inputProps={{ min: 0 }}
                                disabled={editId !== question.questionId.questionId}
                                sx={{
                                    width: '50px',
                                    "& .MuiOutlinedInput-input": {
                                        color: "#747247",
                                        border: 'none !important',
                                        padding: '0px !important'
                                    },
                                    textAlign: 'center', border: 'none'
                                }}
                                onChange={(e) => { setcolorHex(e.target.value) }}
                                value={editId === question.questionId.questionId ? colorHex ? colorHex : question.colorHex : question.colorHex} />
                        </FormControl>

                        <Box component='img' onClick={() => setEditId(question.questionId.questionId)} src={edit} width='20px' height='20px'></Box>
                    </Box>
                    <Box className='px-4 py-1 text-main align-items-center d-flex' width='fit-content' bgcolor='#7472471A'>
                        <Typography>Question Order : {question?.displayOrder ?? 'N/A'}</Typography>
                    </Box>
                    <Box className='px-3 py-2 text-main mt-2 align-items-center d-flex' width='50%' borderRight='1px solid #747247' bgcolor='#7472471A'>
                        <Typography>Question Group: &nbsp;</Typography>
                        <FormControl sx={{ width: '60%' }}>
                            <Select
                                disabled={editId !== question.questionId.questionId}
                                onChange={(e) => { setquestionGroup(e.target.value) }}
                                value={editId === question.questionId.questionId ? questionGroup ? questionGroup : question.questionGroup : question.questionGroup}
                                displayEmpty
                                sx={{
                                    width: '',
                                    '&.MuiSelect-root': {
                                        width: '100%'
                                    },
                                    "& .MuiOutlinedInput-input": {
                                        color: "#747247",
                                        border: 'none !important',
                                        padding: '0px !important'
                                    },
                                    paddingLeft: '10px',
                                    textAlign: 'start', border: 'none'
                                }}
                            >
                                <MenuItem value="">
                                    None
                                </MenuItem>
                                <MenuItem value="M">Moments that matter</MenuItem>
                                <MenuItem value="C">Compliance</MenuItem>
                                <MenuItem value="L">Liquid</MenuItem>
                            </Select>
                        </FormControl>
                        <Box component='img' onClick={() => setEditId(question.questionId.questionId)} src={edit} width='20px' height='20px'></Box>
                    </Box>
                    <Box className='px-3 py-2 text-main mt-2 align-items-center d-flex' width='fit-content' bgcolor='#7472471A'>
                        <Typography>Question Label: &nbsp;</Typography>
                        <FormControl>
                            <TextField
                                disabled={editId !== question.questionId.questionId}
                                sx={{
                                    width: '50px',
                                    "& .MuiOutlinedInput-input": {
                                        color: "#747247",
                                        border: 'none !important',
                                        padding: '0px !important'
                                    },
                                    textAlign: 'center', border: 'none'
                                }}
                                onChange={(e) => { setquestionLabel(e.target.value) }}
                                value={editId === question.questionId.questionId ? questionLabel ? questionLabel : question.questionLabel : question.questionLabel} />
                        </FormControl>
                        <Box component='img' onClick={() => setEditId(question.questionId.questionId)} src={edit} width='20px' height='20px'></Box>
                    </Box>

                </Box>
                <Typography className="d-flex">
                    Description: &nbsp;<span dangerouslySetInnerHTML={{ __html: decodeHtml(question.questionId.questionDescription) }} />
                </Typography>
                <Typography className="d-flex">
                    Hint: &nbsp;<span dangerouslySetInnerHTML={{ __html: decodeHtml(question.questionId.questionHint) }} />
                </Typography>

            </Box>
            <Dialog fullWidth open={openQuestionUsage}>
                <Box className='d-flex align-items-center justify-content-between p-3'>
                    <Typography className="fw-bold" variant="h5">Question Usage</Typography>
                    <IconButton onClick={() => { setOpenQuestionUsage(false); setQuestionUsageList([]); }}>
                        <CancelOutlined />
                    </IconButton>
                </Box>
                <Box className='p-3'>
                    {questionUsageList?.businessUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Businesses</Typography>
                            <List sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.businessUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item !important", listStyle: 'outside', py: 0 }}>
                                            <Link
                                                to={`/admin/create-client-template/${item?.clientEntityId}`}
                                                // className="table-row-background fs-14 link-btn"
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"
                                            > {item?.entityName}
                                            </Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}

                    {questionUsageList?.venueUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Sites</Typography>
                            <List component="ul" sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.venueUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item", listStyle: 'outside', py: 0 }}>
                                            <Link
                                                to={`/admin/create-venue-site-template/${item?.venueId}`}
                                                // onClick={() => navigateToVenueSiteQuestion(venue)}
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"
                                            >
                                                {item?.venueName}
                                            </Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}
                    {questionUsageList?.templateUsage?.length > 0 && (
                        <Box className='mb-3'>
                            <Typography variant="h6">Question Template</Typography>
                            <List component="ul" sx={{ listStyleType: "disc", pl: 4 }}>
                                {
                                    questionUsageList?.templateUsage?.map((item: any, index: number) => (
                                        <ListItem key={index}
                                            className="px-0"
                                            sx={{ display: "list-item", listStyle: 'outside', py: 0 }}>
                                            <Link to={`/admin/create-new-template/${item?.templateName}/${item?.entityTypeTemplateId}`}
                                                style={{ textDecoration: "underline !important", color: "#75724C" }}
                                                target="__blank"

                                            >
                                                {item?.templateName}</Link>
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Box>
                    )}
                </Box>
            </Dialog>
        </Box>
    );
});

const CategoryCard = forwardRef(({ filter, index, catId, moveCategories, categoryName, addedFilters, setAddedFilters, handleDeleteCategory }: { filter: any; index: number; categoryName: any; catId: number; addedFilters: number[]; setAddedFilters: (id: number[]) => void; moveCategories: (from: number, to: number) => void; handleDeleteCategory: (id: number) => void; }, ref) => {
    const dragRef = useRef<any>(null);
    const dropRef = useRef<any>(null);
    const DISABLE_DND = true;

    const [, drag] = useDrag({
        type: 'CATEGORY',
        item: { index },
    });

    const [, drop] = useDrop({
        accept: 'CATEGORY',
        hover: (draggedItem: DragItem) => {
            if (draggedItem.index !== index) {
                moveCategories(draggedItem.index, index);
                draggedItem.index = index;
            }
        },
    });

    if (!DISABLE_DND) {
        drag(dragRef);
        drop(dropRef);
    }

    return (
        <ToggleButton
            ref={(node) => {
                dragRef.current = node;
                dropRef.current = node;
            }}
            className="transform d-flex align-items-center"
            sx={{ gap: 2, fontSize: '16px', whiteSpace: 'nowrap' }}
            key={index}
            value={filter}
        >
            {categoryName}

            <span
                className='d-flex align-items-center'
                onClick={() => {
                    const isConfirm = window.confirm("Are you sure you want to delete this category with question ?")
                    if (isConfirm) {
                        handleDeleteCategory(catId);
                    }
                }
                }
            >
                <CancelOutlined sx={{ fontSize: '18px' }} />
            </span>
        </ToggleButton>
    );
});




function CreateVenueSiteTemplate() {

    const [category, setcategorey] = useState<any>([])
    const [activequestions, setactivequestions] = useState<any>([])
    const [selectedCategory, setselectedCategory] = useState<number | string>('')
    const [TemplateQuestions, setTemplateQuestions] = useState<any>('')
    const [addedFilters, setAddedFilters] = useState<number[]>([]);
    const [alignment, setAlignment] = useState<number>(addedFilters[0]);
    const [reload, setreload] = useState<boolean>(false);
    const [editId, setEditId] = useState<string | null>(null);
    const [editWeighted, setEditWeighted] = useState<string | number>();
    const [editColorHex, setEditcolorHex] = useState<string | number>();
    const [questionGroup, setquestionGroup] = useState<string>('');
    const [questionLabel, setquestionLabel] = useState<string>('');
    const [maxScore, setmaxScore] = useState<string | number>();
    const [refresh, setRefresh] = useState<number>(0);
    // const [questionIndexMap, setquestionIndexMap] = useState<any>();
    const [ischange, setischange] = useState<boolean>(false);
    const [iscategorychange, setiscategorychange] = useState<boolean>(false);
    const navigate = useNavigate()
    const [newCategoryId, setNewCategoryId] = useState<any>(null);
    const [open, setOpen] = useState(false);
    const [categoryName, setCategoryName] = useState<any>(null);
    const [SelectedTemplate, setSelectedTemplate] = useState<number | string>(0);
    const [template, setTemplate] = useState<any>([])
    const { id } = useParams()
    const [clientData, setClientData] = useState<any>([])
    const location = useLocation();
    const [openSampleReportDialog, setOpenSampleReportDialog] = useState<boolean>(false)
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    // const clientData = location.state?.venue;
    // const clientData = JSON.parse(sessionStorage.getItem('venueQuestion') || "null");

    const OpenEditReport = async (item: any) => {
        try {
            const data = {
                // reportHeaderId: item.reportHeaderId,
                allocationId: item.allocationId,
                clientGroupName: selectedClientName?.clientGroupName
            }
            const res = await ApiReportTempToken(data)
            if (res.success) {
                sessionStorage.setItem('fromOriginalSite', 'true');
                window.open(`${process.env.REACT_APP_SHOPPER_SITE}?x-z-a=${res?.data?.token}`, '_blank');
            }
            else {
                toast.error(res?.message)
            }
        } catch (error: any) {
            toast.error(error?.message)
        }
    }

    const fillSampleReport = async () => {
        try {
            const data = {
                "year": new Date().getFullYear(),
                "venueId": clientData?.venueId,
                "clientEntityId": clientData?.clientEntityId?.clientEntityId,
                "durationType": "custom_month",
                "months": [new Date().getMonth() + 1],
                "createdBy": localStorage.getItem("createdBy")
            }
            const res = await ApiCreateSampleAllocation(data);
            if (res?.status || res?.success) {
                setOpenSampleReportDialog(false)
                OpenEditReport(res?.data?.appliedAllocation)
            }

        } catch (error) {
            alert(error)
        }
    };

    const handleGetVenueList = async () => {
        const data =
            `?venueId=${id}&venueStatus=active`;
        try {
            const response: any = await ApiGetVenueList(data);
            setClientData(response.data[0]);
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    useEffect(() => {
        handleGetVenueList()
    }, [])

    const moveQuestion = (fromIndex, toIndex) => {
        const updatedQuestions = [...activequestions];
        const [movedQuestion] = updatedQuestions.splice(fromIndex, 1);
        updatedQuestions.splice(toIndex, 0, movedQuestion);
        setactivequestions(updatedQuestions);
        setischange(!ischange)
    };


    const moveCategories = (fromIndex, toIndex) => {
        const updatedCategories = [...addedFilters];
        const [movedCategory] = updatedCategories.splice(fromIndex, 1);
        updatedCategories.splice(toIndex, 0, movedCategory);
        setAddedFilters(updatedCategories);
        setiscategorychange(!iscategorychange)
    };

    const handleQuestionListUpdate = () => {
        setRefresh((prev) => prev + 1);
    };


    useEffect(() => {
        if (category.length > 0) {
            setselectedCategory(category[category.length - 1].categoryId);
        }
    }, [selectedCategory, category]);

    useEffect(() => {
        const fetchcategory = async () => {
            try {
                const categories = await GetCategories()
                setcategorey(categories.data)
            }
            catch (error) {
                toast.error(error)
            }

        }
        fetchcategory()
    }, [])

    const fetchtselectedquestions = async () => {
        if (!clientData?.venueId) return;
        try {
            const response = await GetVenueQuestions(clientData?.venueId)
            if (!response?.data) {
                setAddedFilters([])
            }
            let filteredquestions: any[] = [];
            let filteredcategories: any[] = [];
            setreload(false)
            // setiscategorychange(true)
            const categoryIds = response.categoryDisplayOrderIds
                ? response.categoryDisplayOrderIds.split(',').filter((id) => id.trim() !== '').map((id) => parseInt(id.trim(), 10))
                : [];

            categoryIds.map((orderId) => {
                response.data.forEach((question) => {
                    if (question.questionId.categoryId.categoryId === orderId) {
                        // console.log(question.questionId.categoryId.categoryId);
                        filteredquestions = [...filteredquestions, question];
                    }
                })
            })
            filteredquestions.length > 0 ? setTemplateQuestions(filteredquestions) : setTemplateQuestions(response.data)

            filteredquestions.map(item => {
                filteredcategories = [...new Set([...filteredcategories, item.questionId.categoryId.categoryId])];
            })

            // console.log("FilteredCategories", filteredcategories);
            // console.log("Json filtered", JSON.stringify(filteredcategories));
            // console.log("Json addedd", JSON.stringify(addedFilters));

            if (filteredcategories.length > 0 && filteredquestions.length > 0 && JSON.stringify(filteredcategories) !== JSON.stringify(addedFilters)) {
                setAddedFilters(filteredcategories);
                setAlignment(filteredcategories[0])
            }
            else if (filteredcategories.length < 1) {
                let f_Categories
                // response.data.length > 0 && response.data.map(item => {
                //     console.log("New Data---->", addedFilters)
                //     setAddedFilters(prevFilters =>
                //         prevFilters.includes(item.questionId.categoryId.categoryId)
                //             ? prevFilters
                //             : [...prevFilters, item.questionId.categoryId.categoryId]
                //     );

                // })
                if (response.data.length > 0) {
                    const newCategoryIds = response.data.map(
                        item => item.questionId.categoryId.categoryId
                    );

                    setAddedFilters(prevFilters => {
                        const updatedFilters = [
                            ...new Set([...prevFilters, ...newCategoryIds])
                        ];
                        return updatedFilters;
                    });
                }
                setAlignment(response.data[0].questionId.categoryId.categoryId)
            }
            if (localStorage.getItem('alignment')) {
                setAlignment(Number(localStorage.getItem('alignment')))
                setTimeout(() => {
                    localStorage.removeItem('alignment')
                }, 1000);
            }
        }
        catch (error) {
            toast.error(error)
        }

    }
    useEffect(() => {

        clientData && fetchtselectedquestions()
    }, [reload, refresh, clientData])

    const handleChange2 = (event) => {
        setAddedFilters([...new Set([...addedFilters, event])])
    };

    const handleAlignment = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: number,
    ) => {
        setAlignment(newAlignment);
    };

    const removequestion = async (clientEntityQuestionVenueId) => {
        const isdelete = window.confirm("Are you sure you want to delete this questions")
        if (isdelete) {

            try {
                const response = await RemoveVenueQuestions(clientEntityQuestionVenueId, clientData?.venueId)
                toast.success(response.message)
                setreload(true)
            }
            catch (error) {
                toast.error(error)
            }
        }

    }
    const updatequestion = async (clientEntityQuestionVenueId) => {
        const data = {
            clientEntityQuestionVenueId: clientEntityQuestionVenueId,
            ...(editWeighted && { questionWeightage: Number(editWeighted) }),
            ...(maxScore && { maxScore: Number(maxScore) }),
            ...(editColorHex && { colorHex: editColorHex }),
            ...(questionGroup && { questionGroup: questionGroup }),
            ...(questionLabel && { questionLabel: questionLabel })
        }
        try {
            console.log("clientEntityQuestionVenueId", clientEntityQuestionVenueId);

            const response = await UpdateVenueQuestions(data)
            localStorage.setItem('alignment', alignment.toString())
            toast.success(response.message)
            setreload(true)
            setEditId(null)
        }
        catch (error) {
            toast.error(error)
        }

    }
    // const AddQuestions = async () => {
    //     const data = {
    //         clientEntityId: clientData?.clientEntityId?.clientEntityId,
    //         venueId: clientData?.venueId,
    //         createdBy: Number(localStorage.getItem('createdBy')),
    //     }
    //     try {
    //         const response = await AddVenueQuestions(data)
    //         toast.success(response.message)
    //     }
    //     catch (error) {
    //         toast.error(error)
    //     }
    //     // console.log(response);

    // }

    useEffect(() => {
        if (TemplateQuestions) {
            const activeCategory = TemplateQuestions.filter(q => q.questionId.categoryId.categoryId === alignment)
                .sort((a, b) => a.displayOrder - b.displayOrder);
            setactivequestions(activeCategory);
        }
    }, [alignment, TemplateQuestions]);

    useEffect(() => {
        if (TemplateQuestions) {
            if (activequestions) {
                const updatequestionOrder = async () => {
                    const updatedMap = {
                        type: "venue_questions",
                        questionOrders: activequestions?.map((question, index) => ({
                            clientEntityQuestion_venue_id: question.clientEntityQuestionVenueId,
                            displayOrder: index
                        })) || []
                    };
                    try {
                        const response = await UpdateVenueQuestionOrder(updatedMap)
                        // alert(response.message)
                    }
                    catch (error) {
                        toast.error(error)
                    }
                }
                updatequestionOrder()
            }
        }
    }, [ischange]);


    const updateCategoryOrder = async () => {
        // alert(`Added filter length, ${addedFilters.length}`)
        if (addedFilters.length == 0 || category.length == 0) return;
        const updatedCategory = {
            type: "venue_questions",
            venueId: clientData?.venueId,
            categoryDisplayOrderIds: addedFilters?.length > 0 && addedFilters.map((filter, index) => {
                const matchedCategory = category.find((cat) => cat.categoryId === filter);
                const categoryName = matchedCategory ? matchedCategory.categoryName : "Unknown";
                const categoryId = matchedCategory && matchedCategory.categoryId;
                return categoryId
            })
                .join(",")
        };
        try {
            const response = await UpdateVenueCategoryOrder(updatedCategory)
            if (response.status) {
                fetchtselectedquestions()
            }
            // alert(response.message)
        }
        catch (error) {
            toast.error(error)
        }
    }
    // useEffect(() => {
    //     console.log("Added filter Length", addedFilters)

    //     if (TemplateQuestions && addedFilters && category) {
    //         const updateCategoryOrder = async () => {
    //             // if (addedFilters.length == 0 || category.length == 0) return;

    //             const validCategoryIds = addedFilters
    //                 .map((filter) => category.find((cat: any) => cat.categoryId === filter)?.categoryId)
    //                 .filter(Boolean);

    //             if (validCategoryIds.length === 0) return;

    //             const updatedCategory = {
    //                 type: "venue_questions",
    //                 venueId: clientData?.venueId,
    //                 categoryDisplayOrderIds: validCategoryIds.join(",")
    //             };

    //             try {
    //                 await UpdateVenueCategoryOrder(updatedCategory);
    //                 fetchtselectedquestions();
    //             }
    //             catch (error) {
    //                 toast.error(error)
    //             }
    //         }
    //         updateCategoryOrder()
    //     }
    // }, [addedFilters, category]);

    const downaloadAsExcel = async () => {
        try {

            const data = `?venueId=${clientData?.venueId}`
            const res = await ApiGetVenueQuestionExcel(data);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${clientData?.venueName}_question.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    };
    const handleCloseDialog = () => {
        setOpen(false);
        setNewCategoryId(null)
    };
    const handleCopyQuestion = async () => {
        const questionIds = activequestions.map((q: any) => q.questionId.questionId) || [];
        if (!newCategoryId) {
            toast.error("Please Select Category To Replace.");
            return
        }
        if (!alignment) {
            toast.error("Please Select Category");
            return;
        }
        try {
            const data = {
                newCategoryId: newCategoryId,
                venueId: clientData?.venueId,
                oldCategoryId: alignment,
                questions: questionIds
            }
            const res = await ApiCopyVenueCategoryQuestion(data);
            toast.success(res.message);
            setOpen(false);
            fetchtselectedquestions();
            handleCloseDialog();
        } catch (error: any) {
            console.error("Error Copying Question", error);
            toast.error(error)
        }
    }

    useEffect(() => {
        const fetchcategory = async () => {
            const categories = await GetCategories()
            setcategorey(categories.data)
        }
        const GetTemplate = async () => {
            try {
                const response = await GetQuestionTemplate()
                setTemplate(response.data)

            }
            catch (error) {
                toast.error(error)
            }
        }
        GetTemplate()
        fetchcategory()
    }, [])

    const AddQuestions = async () => {
        if (!SelectedTemplate) {
            toast.error("Please Select Template")
            return;
        }
        const isAdd = window.confirm("Are you sure? It will delete the current question");

        if (!isAdd) return;

        try {
            // await removequestion(true);

            const data = {
                venueId: clientData.venueId,
                entityTypeTemplateId: SelectedTemplate,
                createdBy: Number(localStorage.getItem('createdBy')),
            };

            const response = await ApiaddvenuequestionsWithTemplateId(data);

            toast.success(response.message);
            setreload(true);
        } catch (error) {
            toast.error(error);
        }
    };

    const handleDeleteCategory = async (id: any) => {
        try {
            const data = {
                type: "venue_questions",
                venueId: clientData?.venueId,
                categoryDisplayOrderId: id
            }
            const res = await ApiDeleteCatgory(data);
            if (res.status) {
                fetchtselectedquestions();
                toast.success(res.message)
            }
        } catch (error: any) {
            console.error("Error Deleting Category:", error)
            toast.error(error);
        }
    }

    const downaloadSampleReport = async (venue: any) => {
        try {
            const data = `?clientEntityId=${venue?.clientEntityId?.clientEntityId}&venueId=${venue?.venueId}`
            const res = await ApiSampleReport(data);

            const blob = new Blob([res], {
                type: 'application/pdf',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${venue?.venueName}_Sample_Report.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    };

    const downaloadQuestions = async (venueId: number, entityName: string, venueName: string) => {
        try {
            const data = `?venueId=${venueId}&entityName=${entityName}&venueName=${venueName}`
            const res = await ApiDowloadQuestions(data);
            const blob = new Blob([res], {
                type: 'application/pdf',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${venueName} (${entityName})-Questions.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            // alert(error)
            toast.error("Please set the question and category order, then try again.");
        }
    }
    return (
        <Box className='container-fluid bg-light create-new-template extra' boxShadow='0px 0px 3px #000000' minHeight='calc(100vh - 165px)' padding='20px'>
            <Box className='d-flex align-items-center justify-content-between'>
                <Typography className='fs-18'>{clientData?.venueName}</Typography>
                <Box className='d-flex' gap={2}>
                    <Button className='bg-grey  text-light whitespace px-3 py-2' onClick={() => setOpen(true)}>Update Category</Button>
                    <Button className='bg-grey px-3 py-1 text-light whitespace px-3 py-2' onClick={() => { downaloadAsExcel() }}>Download As Excel</Button>
                    <Button className='bg-grey px-3 py-1 text-light whitespace px-3 py-2' onClick={() => { removequestion(true) }}>Clear All</Button>
                    {/* <Button className='bg-grey px-3  py-1 text-light whitespace px-3 py-1' onClick={AddQuestions}>Add Questions</Button> */}
                </Box>


            </Box>
            <Divider className='mt-3 mb-4' />
            <Box className='d-flex align-items-center justify-content-between mb-3'>
                <Box className='w-50 ' gap={2}>
                    <Typography gutterBottom style={{ fontSize: "12px" }}>Import Questions</Typography>
                    <Box className='d-flex border  p-3 align-items-stretch justify-content-between' gap={2}>
                        <FormControl fullWidth>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={SelectedTemplate}
                                onChange={(e) => { setSelectedTemplate(e.target.value) }}
                            >
                                <MenuItem value={0} selected>Select Template</MenuItem>
                                {template.length > 0 &&
                                    template.map((temp, index) => (
                                        <MenuItem value={temp.entityTypeTemplateId} key={index}>
                                            {temp.templateName}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <Button className='bg-grey  text-light whitespace px-3 py-1' onClick={AddQuestions}>Add Questions</Button>
                    </Box>
                </Box>
                <Box className='d-flex align-items-center justify-content-end my-1 mb-3' gap={2}>
                    <Button
                        variant="contained"
                        onClick={() => downaloadQuestions(clientData.venueId, clientData?.clientEntityId.entityName, clientData?.venueName)}
                        className="table-row-background fs-14"
                    >
                        Download Questions
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => setOpenSampleReportDialog(true)}
                        className="table-row-background fs-14"
                    >
                        Sample Report
                    </Button>
                    <Link
                        to={`/admin/change-venue-question-order/${clientData?.venueName}/${clientData?.venueId}`}
                        className='bg-grey  text-light whitespace px-3 py-1 link-btn'
                    >
                        Change Order
                    </Link>
                </Box>
            </Box>

            <Box className='d-flex' gap={2}>
                <Box className='w-50 p-2' border='1px solid #E0E0E0'>
                    <QuestionList
                        entityTypeTemplateId={null}
                        onUpdate={handleQuestionListUpdate}
                        venueId={clientData?.venueId}
                        clientEntityId={clientData?.clientEntityId?.clientEntityId} />

                </Box>
                <Box className='w-50 p-2' border='1px solid #E0E0E0'>
                    <Typography className='fs-18 fw-bold mb-2 mt-1'>{clientData?.venueName} Finalised Questions</Typography>
                    <Box className='d-flex align-items-stretch'>
                        <FormControl className='col-2'>
                            <Select value={selectedCategory ?? ''} renderValue={() => "Select Category"} onChange={(e) => { setselectedCategory(Number(e.target.value)); handleChange2(e.target.value) }}>

                                {category.length > 0 &&
                                    category.map((cat, index) => (
                                        <MenuItem value={cat.categoryId} key={index}>
                                            {cat.categoryName}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>


                        <ToggleButtonGroup
                            sx={{ overflow: 'auto' }}
                            color="primary"
                            value={alignment || 0}
                            exclusive
                            onChange={handleAlignment}
                            aria-label="Platform"
                        >

                            <DndProvider backend={HTML5Backend}>
                                {addedFilters?.length > 0 && addedFilters.map((filter, index) => {
                                    const matchedCategory = category.find((cat) => cat.categoryId === filter);
                                    const categoryName = matchedCategory ? matchedCategory.categoryName : "Unknown";
                                    const catId = matchedCategory && matchedCategory.categoryId;
                                    return (

                                        <CategoryCard key={index} catId={catId} categoryName={categoryName} addedFilters={addedFilters} setAddedFilters={setAddedFilters} filter={filter} index={index} moveCategories={moveCategories} handleDeleteCategory={handleDeleteCategory} />
                                    )
                                })}
                            </DndProvider>
                        </ToggleButtonGroup>

                    </Box>

                    <DndProvider backend={HTML5Backend}>
                        {/* {TemplateQuestions?.length > 0 && TemplateQuestions.map((question, index) => (
                            alignment === question.questionId.categoryId?.categoryId && (

                                <QuestionCard key={index} setEditId={setEditId} removequestion={removequestion} updatequestion={updatequestion} editWeighted={editWeighted} setEditWeighted={setEditWeighted} editId={editId} question={question} index={index} moveQuestion={moveQuestion} />
                            )))} */}
                        {
                            activequestions?.length > 0 && activequestions.map((question, index) => {
                                return (
                                    <QuestionCard clientData={clientData} colorHex={editColorHex} questionGroup={questionGroup} questionLabel={questionLabel} setquestionLabel={setquestionLabel} setquestionGroup={setquestionGroup} setcolorHex={setEditcolorHex} key={index} setEditId={setEditId} removequestion={removequestion} updatequestion={updatequestion} editWeighted={editWeighted} setEditWeighted={setEditWeighted} maxScore={maxScore} setmaxScore={setmaxScore} editId={editId} question={question} index={index} moveQuestion={moveQuestion} setreload={setreload} />
                                )
                            }
                            )

                        }
                    </DndProvider>


                </Box>
            </Box>
            <Dialog
                open={open}
                onClose={handleCloseDialog}
                maxWidth={false}
                PaperProps={{
                    sx: {
                        width: "400px",
                        height: "400px",
                        maxWidth: "none",
                    },
                }}
            >
                <DialogTitle>
                    Select New Category
                </DialogTitle>

                <DialogContent>
                    <Box sx={{ mt: 2 }}>
                        <Autocomplete
                            disablePortal
                            id="mm-autocomplete"
                            options={category}
                            getOptionLabel={(option: any) => `${option?.categoryName}`}
                            value={category.find((option: any) => option.categoryId === newCategoryId) || null}
                            onChange={(event, newValue) => {
                                setNewCategoryId(newValue?.categoryId)
                                setCategoryName(newValue?.categoryName)
                            }}
                            defaultValue=""
                            renderInput={(params) => <TextField {...params} label="Select Category" />}
                            size="small"
                        />
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseDialog} sx={{ color: "#ADB792", borderColor: "#ADB792", }} variant='outlined'>
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            const alignedCategory = category.find(
                                (cat: any) => cat.categoryId === alignment
                            );

                            const alignedCategoryName = alignedCategory?.categoryName || "";
                            const isConfirm = window.confirm(`Are you sure you want to update ${alignedCategoryName} category to ${categoryName} category?`)
                            if (isConfirm) {
                                handleCopyQuestion()
                            }
                        }}
                        variant="contained"
                        className='table-row-background'
                    >
                        Update
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openSampleReportDialog}
                onClose={() => { setOpenSampleReportDialog(false) }}
                maxWidth={'xl'}
                PaperProps={{
                    sx: {
                        width: "500px",
                        height: "fit-content",
                        p: 2
                    },
                }}
            >
                <Box className='d-flex justify-content-between align-items-center mb-3'>
                    <Typography variant='h5'>Sample Report</Typography>
                    <IconButton onClick={() => setOpenSampleReportDialog(false)} >
                        <CancelOutlined />
                    </IconButton>
                </Box>
                <Box className='d-flex align-items-center justify-content-center mt-2' gap={2}>
                    <Button
                        variant="contained"
                        onClick={() => downaloadSampleReport(clientData)}
                        className="table-row-background fs-14"
                    >
                        Download Empty Report
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => fillSampleReport()}
                        className="table-row-background fs-14"
                    >
                        Fill Report
                    </Button>
                </Box>
            </Dialog>
        </Box>
    )
}

export default CreateVenueSiteTemplate
